<div class="update-field-details-main-container">
    <div class="update-field-details-close-container">
        <div class="header">Edit Field Details</div>
        <div class="close-icon" (click)="closeDialog()">X</div>
    </div>

    <app-season-field-details
            *ngIf="seasonFormData && seasons"
            [seasons]="seasons"
            (emitCloseDialog)="closeDialog()"
            (emitDataRefresh)="linkSeasonToField()"
            [seasonFormData]="seasonFormData"
            [fieldId]="fieldId"
    ></app-season-field-details>

    <!-- Definition Tabs -->
    <div class="definitions-container" *ngIf="seasonFormData?.details?.length > 0">
        <div class="definitions-header">
            <span class="definitions-label">Crop Definitions</span>
            <button mat-icon-button color="primary" (click)="addDefinition()"
                [title]="cultivarSizeInvalid ? 'Fix the cultivar size before adding a definition' : 'Add Definition'"
                [disabled]="!seasonFormData?.field?.isInAnotherActiveSeason || cultivarSizeInvalid">
                <mat-icon>add_circle</mat-icon>
            </button>
        </div>
        <mat-tab-group [(selectedIndex)]="selectedDefinitionIndex" (selectedIndexChange)="onDefinitionTabChange($event)">
            <mat-tab *ngFor="let def of seasonFormData.details; let i = index"
                [disabled]="cultivarSizeInvalid && i !== selectedDefinitionIndex">
                <ng-template mat-tab-label>
                    <div class="def-tab-label flex items-center justify-between w-full min-w-[140px]">
                        <span class="text-[11px]">{{ getDefinitionLabel(def, i) }}</span>
                        <div *ngIf="seasonFormData.details.length > 1 && seasonFormData?.field?.isInAnotherActiveSeason" class="flex items-center justify-end pl-3">
                            <span class="def-tab-close material-icons text-[11px] text-[var(--notification-error)] cursor-pointer opacity-0 transition-opacity"
                                (click)="deleteDefinition(def, $event)">close</span>
                        </div>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>

    <!-- Section Tabs: Field Data / Crop Detail / Cost -->
    <div class="flex gap-0 px-4 border-b border-[var(--app-base)] mt-2 mb-2">
        <button (click)="panelTab = 'field'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            [disabled]="cultivarSizeInvalid && panelTab !== 'field'"
            [title]="cultivarSizeInvalid && panelTab !== 'field' ? 'Fix the cultivar size first' : ''"
            [ngClass]="panelTab === 'field' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Field Data</button>
        <button (click)="panelTab = 'crop'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            [disabled]="cultivarSizeInvalid && panelTab !== 'crop'"
            [title]="cultivarSizeInvalid && panelTab !== 'crop' ? 'Fix the cultivar size first' : ''"
            [ngClass]="panelTab === 'crop' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Crop Detail</button>
        <button (click)="panelTab = 'cost'" class="py-2 px-3 text-[11px] font-semibold border-b-2 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            [disabled]="cultivarSizeInvalid && panelTab !== 'cost'"
            [title]="cultivarSizeInvalid && panelTab !== 'cost' ? 'Fix the cultivar size first' : ''"
            [ngClass]="panelTab === 'cost' ? 'text-[var(--primary-dark)] border-[var(--primary-dark)]' : 'text-[var(--tertiary-text)] border-transparent'">Cost</button>
    </div>

    <div class="flex-1 overflow-y-auto overflow-x-hidden">
        <app-season-field-input *ngIf="seasonFormData" [sharedExtraDetailData]="sharedExtraDetailData" [inputData]="currentDefinition" [siblingDefinitions]="seasonFormData.details" [serverCultivarSizeError]="cultivarSizeServerError" [isInAnotherActiveSeason]="seasonFormData.field.isInAnotherActiveSeason" [panelTab]="panelTab" (formDataChange)="onFormDataChange($event)"></app-season-field-input>
    </div>

    <div class="update-details-btn-container">
        <button class="update-button" mat-flat-button type="button" (click)="saveAndStayOpen()"
            [disabled]="cultivarSizeInvalid"
            [title]="cultivarSizeInvalid ? 'Fix the cultivar size before saving' : ''">
            Update Details
        </button>
    </div>

</div>
